import { MessagesModel } from "./Messages.model";
import { AttachmentModel } from "./Attachment.model";
export class StatusChangeByComponentView {
    public IdRequest: number;
    public IdComponent: number
    public Approve: boolean
    public IdProfile: number
    Messages:MessagesModel[]
    Attachments:AttachmentModel[]
}